/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Checks whether an input string is a valid URL or not
 *
 * @param {String} text The text to process.
 * @example
 *
 * isValidURL('www.google.com');
 * // -> false
 *
 * isValidURL('https://www.google.com');
 * // -> true
 *
 */

const isValidURL = (text) => {
  if (!text || !text.trim()) {
    return false;
  }

  try {
    const url = new URL(text.trim());
    return !!url;
  } catch {
    return false;
  }
};

export default isValidURL;
